<template>
  <div class="auth-brand-header">
    <a :href="homeUrl" class="auth-brand-lockup">
      <img v-if="brandLogo" :src="brandLogo" alt="" class="auth-brand-logo">
      <v-icon v-else class="auth-brand-icon">{{ brandIcon }}</v-icon>
      <span class="auth-brand-wordmark">{{ productName }}</span>
      <span v-if="showBetaBadge" class="auth-brand-beta">BETA</span>
    </a>
    <p v-if="brandTagline" class="auth-brand-tagline">{{ brandTagline }}</p>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "AuthBrandHeader",
  props: {
    tagline: { type: String, default: "" },
    icon: { type: String, default: "" },
    homeUrl: { type: String, default: "/" }
  },
  computed: {
    productName() {
      return config.PRODUCT_NAME || "MultiSaaS";
    },
    brandIcon() {
      return this.icon || config.BRAND_ICON || "mdi-rocket-launch";
    },
    // Optional app logo image (config.BRAND_LOGO) in place of the icon; none by default.
    brandLogo() {
      return config.BRAND_LOGO || "";
    },
    // Absent config => shown; an app opts out with BETA_BADGE: false.
    showBetaBadge() {
      return config.BETA_BADGE !== false;
    },
    brandTagline() {
      return this.tagline || config.TAGLINE || "";
    }
  }
};
</script>

<style scoped>
.auth-brand-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  text-align: center;
}

.auth-brand-lockup {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
}

.auth-brand-lockup:hover {
  text-decoration: none;
}

.auth-brand-logo {
  width: 32px;
  height: 32px;
  margin-right: 10px;
  border-radius: 8px;
}

.auth-brand-icon {
  color: var(--text-heading) !important;
  margin-right: 8px;
  font-size: 28px !important;
}

.auth-brand-wordmark {
  color: var(--text-heading);
  font-weight: 700;
  letter-spacing: -1.2px;
  font-size: 1.75rem;
  line-height: 1;
}

.auth-brand-beta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--gradient-button);
  color: var(--button-text-dark);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 3px 10px;
  margin-left: 10px;
  border-radius: 12px;
  box-shadow: 0 2px 8px var(--shadow-primary-glow);
  line-height: 1;
  position: relative;
  top: -1px;
}

.auth-brand-tagline {
  margin: 10px 0 0 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  letter-spacing: 0.1px;
}

@media (max-width: 600px) {
  .auth-brand-logo {
    width: 28px;
    height: 28px;
  }
  .auth-brand-icon {
    font-size: 24px !important;
  }
  .auth-brand-wordmark {
    font-size: 1.5rem;
  }
}
</style>
